export default __webpack_public_path__ + "static/media/PEEKImg.54f6c74d.jpg";